import request from 'graphql-request';
import { graphql } from '../../../gql/api-wr-tools/gql';
import type {
  BrainToolsHomeworkHelperGenerateTitleMutation,
  BrainToolsHomeworkHelperGenerateTitleMutationVariables,
} from '../../../gql/api-wr-tools/graphql';
import { IResponseData } from '../../../typings/common';
import { Endpoint } from '../../endpoint';

const mutation = graphql(/* GraphQL */ `
  mutation BrainToolsHomeworkHelperGenerateTitle(
    $clientHash: String!
    $instructions: String
    $instructionsFromFiles: [String]
  ) {
    brainToolsHomeworkHelperGenerateTitle(
      clientHash: $clientHash
      instructions: $instructions
      instructionsFromFiles: $instructionsFromFiles
    ) {
      status {
        code
        message
      }
      title
    }
  }
`);

interface IHomeworkHelpTitleResult {
  title: string | null;
}

export const generateTitleHomeworkHelp = async (
  payload: BrainToolsHomeworkHelperGenerateTitleMutationVariables
): Promise<IResponseData<IHomeworkHelpTitleResult>> => {
  const response = await request<
    BrainToolsHomeworkHelperGenerateTitleMutation,
    BrainToolsHomeworkHelperGenerateTitleMutationVariables
  >(Endpoint.GRAPHQL_WRITING_TOOLS_AI_CALL, mutation, payload);

  const {
    brainToolsHomeworkHelperGenerateTitle: { title, status },
  } = response;

  const result: IHomeworkHelpTitleResult = {
    title: title ?? null,
  };

  return {
    data: result,
    status: status.code,
    message: status.message,
  };
};
